// extracted by mini-css-extract-plugin
module.exports = {"component":"App_component__3J_JI","main":"App_main__uN9ca","footer":"App_footer__3csul"};